module.exports = __webpack_public_path__ + "img/lavender-new-logo.f256b857.jpg";